<template>
  <ul v-if="data" class="NavBox" :class="classes">
    <li class="NavBox__item" :class="navItemClasses(index)" v-for="(item, index) in data" :key="index">
      <button @click="updateItem(index)" type="button">{{ item.name}}</button>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'NavBox',

    props: {
      data: {
        type: Array,
        required: true
      },
      activeNumber: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 3
      },
      theme: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        transitionDuration: 0,
        transitionDelay: 50,
        variationTotal: 8,
        start: true
      }
    },

    computed: {
      classes() {
        return {
          [`NavBox--theme--${this.theme}`]: this.theme,
          [`NavBox--start`]: this.start
        }
      }
    },

    mounted() {
      this.updateShowClasses()
    },

    methods: {
      updateShowClasses() {
        for (let i = 0; i < this.data.length; i++) {
          setTimeout(() => {
            const element = document.getElementsByClassName(
              `NavBox__item--index--${i}`
            )
            if (element[0]) {
              element[0].classList.add('NavBox__item--show')
            }
          }, this.transitionDelay * i)
        }
        setTimeout(() => {
          this.$emit('animation-end')
          this.start = false
        }, this.transitionDelay * this.data.length + 1)
      },
      navItemClasses(index) {
        return {
          [`NavBox__item--active NavBox__item--show`]: this.data[index].active,
          [`NavBox__item--index--${index}`]: this.data[index],
          //[`NavBox__item--animate`]: this.data[index].animate
        }
      },
      updateItem(index) {
        if (this.activeNumber > this.max - 1) {
          // If 3 flavours chosen we want to disable adding more flavours
          return this.maxItemsReached(index)
        }
        this.data[index].active = !this.data[index].active
        if (this.data[index].active) {
          this.data[index].animate = !this.data[index].animate
        }
        this.$emit('checkActiveStates')
      },
      maxItemsReached(index) {
        if (this.data[index].active) {
          this.data[index].active = false
        }
        this.$emit('checkActiveStates')
        return
      }
    }
  }
</script>

<style lang="scss">
  @import '../scss/variables.scss';
  @import '../scss/mixins.scss';

  .NavBox {
    display: flex;
    flex-wrap: wrap;
    margin: 0 1.250em 1.875em 1.25em;
    width: calc(100% - 2.5em);

    &--start {
      .NavBox__item {
        opacity: 0;
      }
      .NavBox__item--show {
        opacity: 1;
      }
    }
    &__item {
      //Commenting out as Client no longer wants borders
      //border: 1px solid $black;
      border-bottom-width: 0;
      box-sizing: border-box;
      width: 50%;
      transition: all 0.66s ease-in-out;

      button {
        background: transparent;
        border: 0;
        cursor: pointer;
        display: block;
        padding: 1.25em;
        width: 100%;
        height: 100%;
        color: $light-font-color;
        text-transform: uppercase;
        font-family: $primary-font;
        font-size: 14px;
        letter-spacing: 1.5px;
        text-align: center;
        transition: opacity $transition;
        &:focus {
          outline:0;
        }
      }

      &--animate {
        button {
          animation: fadein 0.5s;
        }

        @keyframes fadein {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      }

      &--active {
        button {
          color: $black;
          background-image: linear-gradient(49deg, #AF695B 0%, #C09C83 57%, #AF695B 100%);
          opacity: 0.5;
        }
      }

      // Target specific elements so no double borders
      // Client no longer wants borders
      /*
      &:nth-child(even) {
        border-left-width: 0;
      }

      &:nth-last-of-type(-n+2) {
        border-bottom-width: 1px;
      } */
    }

    // Theme overrides
    &--theme--smoke {
      .NavBox__item--active {
        button {
          background-image: linear-gradient(227deg, #8789A9 0%, #A5B0E3 47%, #8789A9 100%);
        }
      }
    }
    &--theme--chard {
      .NavBox__item--active {
        button {
          background-image: linear-gradient(41deg, #A27C5C 0%, #E1B87F 50%, #A27C5C 100%);
        }
      }
    }

  }
</style>
